import type { Product } from '#root/api/clients/product/data-contracts'

/**
 * Whether the supplied product is a Customs (configurable) product. A product qualifies when it
 * has a customs recipe (external URL or recipe id) **and** at least one of `isCustoms`,
 * `dummyCustoms`, or `customsCustomizer` is set on the payload.
 * @param productDetail - The product (or a ref/getter resolving to one); `null`-tolerant.
 * @returns `true` when the product is Customs, `false` otherwise.
 * @category Utils
 */
export const isCustomsProduct = (productDetail: MaybeRef<Product | null>) => {
  const product = toValue(productDetail)

  const hasRecipe = !!(product?.customsExternalUrl || product?.customsRecipeID)
  return hasRecipe && !!(product?.isCustoms || product?.dummyCustoms || product?.customsCustomizer)
}
